import { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Text,
  Link,
  List,
  ListItem,
  Flex,
  Grid,
  GridItem,
} from "@chakra-ui/react";

function TermsModal() {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="full">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Bepalings en Voorwaardes/ Terms and Conditions
        </ModalHeader>
        <ModalBody minW={"1000px"} overflowY={"auto"}>
          <Grid>
            <GridItem colStart={1}>
              <Text mb={3} fontWeight="bold">
                Baie welkom by ons aanlynportaal vir oordbesprekings. Lees
                asseblief die bepalings en voorwaardes noukeurig en klik op die
                “Ek aanvaar”-skakel om voort te gaan.
              </Text>
            </GridItem>
            <GridItem colStart={2}>
              <Text mb={3} fontWeight="bold">
                Welcome to our online portal for resort reservations. Please
                read the terms and conditions carefully and click on the “I
                agree” link to continue.
              </Text>
            </GridItem>
          </Grid>

          <Flex direction={"row"}>
            <Flex flex="1" pr={4}>
              <List as="ol" spacing={3} mb={4}>
                <ListItem>
                  Deur van hierdie aanlynbesprekingsportaal gebruik te maak,
                  bevestig jy dat jy jou verbind tot die volgende reëls, en
                  indien die reëls oortree word, sal jou bespreking gekanselleer
                  word, sal inbetaling volgens die nie-ledetarief moet geskied
                  en kan jou lidmaatskapstatus heroorweeg word.
                </ListItem>
                <ListItem>
                  Die standaard oordbepalings en -voorwaardes geld steeds, sowel
                  as die aanlynbesprekingsvoorwaardes wat hier beskikbaar is:{" "}
                  <Link
                    href="https://www.atkvoorde.co.za/bepalings-en-voorwaardes/"
                    isExternal
                    color="blue.500"
                  >
                    https://www.atkvoorde.co.za/bepalings-en-voorwaardes/
                  </Link>
                </ListItem>
                <ListItem>
                  Die persoon wat bespreek, bevestig dat hulle die amptelike lid
                  is wat die bespreking onder hul eie persoonlike ID-nommer maak
                  en dat hulle die bepalings en voorwaardes aanvaar deur op die
                  regte aanlynbesprekingsportaal te bespreek.
                </ListItem>
                <ListItem>
                  Die lid waaronder die bespreking gemaak is, moet tydens
                  aankoms teenwoordig wees met hul ID/paspoort as bewys. Die lid
                  moet ook vir die volle duur van die bespreekte verblyf op die
                  oord teenwoordig wees.
                </ListItem>
                <ListItem>
                  Lede mag onder geen omstandighede die internetskakel (URL) met
                  nie-lede deel nie. Nie-lede wat die skakel gebruik om ŉ
                  bespreking te maak, sal die volle jaarlikse ledegeld of die
                  verskil tussen die lede- en nie-ledetarief moet inbetaal.
                </ListItem>
                <ListItem>
                  Ledetariewe geld slegs vir besprekings wat direk per telefoon,
                  e-pos of deur ons aanlynbesprekingsportaal gemaak word, en
                  deur die ATKV hanteer word, en geld nie vir besprekings wat
                  deur derdepartybesprekingsagente gedoen word nie.{" "}
                  <strong>
                    Let asb. daarop dat inbelbesprekings nie vir hierdie aanbod
                    kwalifiseer nie en dat hierdie ŉ eksklusiewe aanlynaanbod
                    vir lede is.
                  </strong>
                </ListItem>
                <ListItem>
                  Lede wat hulle lidmaatskap maandeliks betaal, moet asb. kennis
                  neem dat hulle eers na ses maande van aktiewe lidmaatskap sal
                  kwalifiseer vir die spesiale tariewe wat aan lede beskikbaar
                  is.
                </ListItem>
                <ListItem>
                  <strong>
                    Lede kan die volgende aantal verblyfeenhede of
                    kampeerstaanplekke teen die ledetarief bespreek:
                  </strong>
                </ListItem>
                <List as="ul" styleType="disc" pl={5}>
                  <ListItem>
                    Tarief 3 (Laag) = 3 (drie) verblyfeenhede of
                    kampeerstaanplekke.
                  </ListItem>
                  <ListItem>
                    Tarief 2 (Middel) = 2 (twee) verblyfeenhede of
                    kampeerstaanplekke.
                  </ListItem>
                  <ListItem>
                    Tarief 1 (Hoog) = 1 (een) verblyfeenheid of
                    kampeerstaanplek.
                  </ListItem>
                </List>
                <ListItem>
                  <Text>
                    Elke oord se tariefkaarte kan onderskeidelik besigtig word
                    op die betrokke oord se webblad, om sodeonde die regte
                    aantal verblyfeenhede of kampeerstaanplekke vir die regte
                    tarief te bespreek.
                  </Text>
                </ListItem>
                <ListItem>
                  Neem ook asb. kennis dat hierdie ledevoordeel slegs opgeneem
                  kan word waar die verblyfeenhede of kampeerstaanplekke almal
                  deel vorm van een bespreking met dieselfde aankoms- en
                  vertrekdatum, en kan dus nie as 2 (twee) of 3 (drie) aparte
                  besprekings opgeneem word nie. Indien 4 (vier) of meer
                  verblyfeenhede of kampeerstaanplekke verlang word, kan die
                  eerste 3 (drie) verblyfeenhede of kampeerstaanplekke deur
                  hierdie portaal bespreek word, en enige bykomende
                  verblyfeenhede of kampeerstaanplekke kan deur
                  <Link
                    href="https://atkvoorde.co.za/bespreek"
                    isExternal
                    color="blue.500"
                  >
                    {" "}
                    www.atkvoorde.co.za/bespreek
                  </Link>{" "}
                  bespreek word. Onderhewig aan beskikbaarheid.
                </ListItem>
                <ListItem>
                  Aankoms- en vertrekdatum moet voor 28 Februarie 2025 wees.
                </ListItem>
              </List>
            </Flex>

            <Flex flex="1" pl={4}>
              <List as="ol" spacing={3}>
                <ListItem>
                  By using the online portal, confirming that you are bound by
                  the following rules, and if you break the rules, your booking
                  will be cancelled and payment will be according to the
                  non-member rate, and your membership may be reconsidered.
                </ListItem>
                <ListItem>
                  The standard resort terms and conditions still apply, as well
                  as the online booking terms available here:{" "}
                  <Link
                    href="https://www.atkvoorde.co.za/bepalings-en-voorwaardes/"
                    isExternal
                    color="blue.500"
                  >
                    https://www.atkvoorde.co.za/bepalings-en-voorwaardes/
                  </Link>
                </ListItem>
                <ListItem>
                  The person making the booking confirms that they are the
                  official member who makes the booking under their personal ID
                  number and that they accept the terms and conditions by
                  booking on the correct online booking portal.
                </ListItem>
                <ListItem>
                  The member who made the booking needs to be present at arrival
                  and present their ID/passport as proof. The member must also
                  be present for the full duration of the stay on the resort.
                </ListItem>
                <ListItem>
                  Members may under no circumstance share the link (URL) with
                  non-members. Non-members who use the link to book, will have
                  to pay the full annual membership fee or the difference
                  between the member and non-member rate.
                </ListItem>
                <ListItem>
                  Member rates only apply to bookings that were made directly
                  over the phone, by email or on our online booking portal,
                  handled by the ATKV, and do not apply to bookings made through
                  third-party booking agents.{" "}
                  <strong>
                    Please note that phone bookings do not qualify for this
                    offer and that this is an exclusive online offer for
                    members.
                  </strong>
                </ListItem>
                <ListItem>
                  Members who pay a monthly membership should note that they
                  will only qualify for the special member tariffs after six
                  months of active membership.
                </ListItem>
                <ListItem>
                  <strong>
                    Members can book the following number of units or camping
                    stands at the member rate:
                  </strong>
                </ListItem>
                <List as="ul" styleType="disc" pl={5}>
                  <ListItem>
                    Rate 3 (Low) = 3 (three) units or camping stands.
                  </ListItem>
                  <ListItem>
                    Rate 2 (Middle) = 2 (two) units or camping stands.
                  </ListItem>
                  <ListItem>
                    Rate 1 (High) = 1 (one) unit or camping stand.
                  </ListItem>
                </List>
                <ListItem>
                  <Text>
                    Each resort's rate card can be confirmed separately on the
                    resorts’ website to book the correct number of units or
                    camping stands at the correct rate.
                  </Text>
                </ListItem>
                <ListItem>
                  Please also note that this member benefit can only be taken up
                  if the units or camping stands all form part of one booking
                  with the same arrival and departure date, and can therefore
                  not be taken up as 2 (two) or 3 (three) separate bookings. If
                  4 (four) or more units or camping stands are required, the
                  first 3 (three) units or camping stands can be booked through
                  this online portal, and any additional units or camping stands
                  can be booked through
                  <Link
                    href="https://atkvoorde.co.za/bespreek"
                    isExternal
                    color="blue.500"
                  >
                    {" "}
                    www.atkvoorde.co.za/bespreek
                  </Link>{" "}
                  Subject to availability.
                </ListItem>
                <ListItem>
                  Arrival and departure dates must be before 28 February 2025.
                </ListItem>
              </List>
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={handleClose}>
            Ek Stem Saam/ I Agree
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default TermsModal;
